import { SiKubernetes } from "@onemind-services-llc/react-icons-ng/si";
import { FaServer, FaMicrosoft } from "@onemind-services-llc/react-icons-ng/fa";
import {
  RiPrinterCloudLine,
  RiFileCloudLine,
} from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineAntDesign } from "@onemind-services-llc/react-icons-ng/ai";
import { PiDesktopTowerBold } from "@onemind-services-llc/react-icons-ng/pi";
import {
  MdStorage,
  MdOutlineAutoMode,
  MdOutlineSettingsBackupRestore,
} from "@onemind-services-llc/react-icons-ng/md";
import {
  BsPersonWorkspace,
  BsFillHddNetworkFill,
  BsServer,
  BsGpuCard,
} from "@onemind-services-llc/react-icons-ng/bs";
import { TiDeviceDesktop } from "@onemind-services-llc/react-icons-ng/ti";

import { ContentCard } from "@/components/contentCard";
import { MAIN_ROUTES, CLOUD_SERVICES_ROUTES } from "@/constants/routes";

export const SERVICES_CONSTANTS = {
  title: "Cloud Services by Onemind ",
  desc: "At Onemind, we offer three key cloud solutions to meet modern business needs: ",
};

export const SERVICES_TABS = {
  PRIVATE_CLOUD: "Private Cloud",
  PUBLIC_CLOUD: "Public Cloud",
  POC_CLOUD: "POC Cloud",
};

export const PrivateCloud_CONSTANTS = {
  tabHead: "Private Cloud",
  title: "Private Cloud – Secure & Scalable Cloud Infrastructure",
  desc: "Private cloud offers dedicated computing resources for businesses that require more control and security. It is ideal for organizations with strict compliance requirements or sensitive workloads, especially those prioritizing advanced cloud security and governance.",
  list: [
    {
      icon: RiPrinterCloudLine,
      title: "Zadara Cloud",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ZADARA_CLOUD}`}
          points={[
            "Pay-as-you-go pricing with no vendor lock-in",
            "Fully managed cloud infrastructure",
            "Guaranteed uptime and enterprise security",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineSettingsBackupRestore,
      title: "Disaster Recovery",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.DISASTER_RECOVERY}`}
          points={[
            "Comprehensive backup and recovery solutions",
            "Minimized downtime and data loss",
            "Compliance with industry standards",
          ]}
        />
      ),
    },
    {
      icon: AiOutlineAntDesign,
      title: "OEM Converged Architecture",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OEM_CONVERGED_ARCHITECTURE}`}
          points={[
            "Optimized infrastructure for OEM applications",
            "Seamless integration with existing IT systems",
            "Improved security, efficiency, and scalability",
          ]}
        />
      ),
    },
    {
      icon: SiKubernetes,
      title: "Private Kubernetes Clusters",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_K8_CLUSTERS}`}
          points={[
            "Network-isolated clusters for enhanced security",
            "Built-in auto-scaling and self-healing capabilities",
            "Seamless integration with hybrid cloud environments",
          ]}
        />
      ),
    },
    {
      icon: FaServer,
      title: "OneMind's Managed Open Stack(MOST)",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OPEN_STACK_CLOUD}`}
          points={[
            "Scalable and modular architecture",
            "Seamless integration with hybrid and multi-cloud",
            "Enterprise-grade security and automation",
          ]}
        />
      ),
    },
    {
      icon: MdStorage,
      title: "Encrypted Storage Clusters",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ENCRYPTED_STORAGE_CLUSTERS}`}
          points={[
            "End-to-end encryption for data at rest & in transit",
            "Fault-tolerant architecture for high availability",
            "Scalable, enterprise-grade cloud storage",
          ]}
        />
      ),
    },
    {
      icon: TiDeviceDesktop,
      title: "VDI on Private Cloud",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_VDI}`}
          points={[
            "Deliver secure, high-performance virtual desktops with Hosted Desktop-as-a-Service (DaaS).",
            "Gain full administrative control using  Microsoft RDS.",
            "Supports MFA, RBAC, and compliance policies for regulated environments.",
          ]}
        />
      ),
    },
    // {
    //   icon: BsPersonWorkspace,
    //   title: "Managed, Unmanaged, Co-managed",
    //   content: (
    //     <ContentCard
    //       link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MANAGED_UNMANAGED_CO_MANAGED}`}
    //       points={[
    //         "Managed: Fully outsourced IT management",
    //         "Unmanaged: Full control over cloud resources",
    //         "Co-managed: Collaboration between your team & experts",
    //       ]}
    //     />
    //   ),
    // },
  ],
};

export const POC_Cloud_CONSTANTS = {
  tabHead: "POC Cloud",
  title: "POC Cloud – Test & Validate Innovations Before Full Deployment",
  desc: "Test, validate, and optimize your applications in a secure and isolated POC environment before full deployment. This approach reduces risks and accelerates innovation cycles while giving teams flexibility to evaluate architectures across private, public, or hybrid cloud computing models.",
  list: [
    {
      icon: RiPrinterCloudLine,
      title: "POC-as-a-Service",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.POC_AS_A_SERVICE}`}
          points={[
            "Real-world testing before production deployment",
            "Quickly validate performance and feasibility",
            "Eliminate costly IT infrastructure investments",
          ]}
        />
      ),
    },
    {
      icon: RiFileCloudLine,
      title: "Lab-as-a-Service",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LAB_AS_A_SERVICE}`}
          points={[
            "Fully managed cloud lab infrastructure",
            "On-demand scalability for experiments & training",
            "Cost-effective & real-world simulation environments",
          ]}
        />
      ),
    },
    {
      icon: BsFillHddNetworkFill,
      title: "Network Digital Twins",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_DIGITAL_TWINS}`}
          points={[
            "Replicate real-world network environments",
            "Optimize configurations & security policies",
            "Predict & prevent network failures before they happen",
          ]}
        />
      ),
    },
    {
      icon: AiOutlineAntDesign,
      title: "Certification Labs",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CERTIFICATION_LABS}`}
          points={[
            "Industry-standard certification environments",
            "Fully virtualized and scalable infrastructure",
            "On-demand access for training & upskilling",
          ]}
        />
      ),
    },
    {
      icon: PiDesktopTowerBold,
      title: "Physical Labs (SI | VAR | COE)",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PHYSICAL_LABS}`}
          points={[
            "Hands-on testing & development environment",
            "Simulate real-world IT infrastructure",
            "Improve solution efficiency before deployment",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineAutoMode,
      title: "Network Automation",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_AUTOMATION}`}
          points={[
            "Self-healing & auto-scaling network configurations",
            "AI-powered traffic optimization & monitoring",
            "Enhance security & compliance with automated policies",
          ]}
        />
      ),
    },
    {
      icon: MdStorage,
      title: "Performance Labs | OEM Test Labs",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PERFORMANCE_LABS}`}
          points={[
            "Replicate production environments for performance validation",
            "Fine-tune applications, networks, and hardware configurations",
            "Ensure stability & efficiency before deployment",
          ]}
        />
      ),
    },
    {
      icon: BsPersonWorkspace,
      title: "Emulate | Simulate | Real",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.EMULATE_SIMULATE_REAL}`}
          points={[
            "Emulation: Replicate real systems with software",
            "Simulation: Predict system behavior under different conditions",
            "Real-world testing: Validate deployments with actual infrastructure",
          ]}
        />
      ),
    },
  ],
};

export const PUBLIC_Cloud_CONSTANTS = {
  tabHead: "Public Cloud",
  title: "Public Cloud – Secure & Scalable Cloud Infrastructure",
  desc: "Public cloud provides businesses with on-demand computing resources over the Internet. It eliminates the need for costly hardware by offering scalable, pay-as-you-go cloud infrastructure, allowing organizations to focus on core operations while benefiting from a trusted public cloud MSP approach.",
  list: [
    {
      icon: FaServer,
      title: "Dedicated Servers ",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.DEDICATED_SERVER}`}
          points={[
            "Exclusive resources with full root and hardware access for complete control.",
            "Customizable to meet the demands of high-traffic websites and compliance-heavy applications.",
            "Ensures reliability and scalability for mission-critical workloads.",
          ]}
        />
      ),
    },
    {
      icon: BsFillHddNetworkFill,
      title: "Shared Compute",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.SHARED_COMPUTE}`}
          points={[
            "Ideal for staging environments, internal tools, and workloads with low CPU demand.",
            "Provision Intel-based virtual machines with predictable performance and fixed resource allocations.",
            "Includes snapshot scheduling, NAT-enabled outbound access, and secure VM isolation.",
          ]}
        />
      ),
    },
    {
      icon: BsServer,
      title: "Bare-Metal Server ",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BAREMETAL}`}
          points={[
            "Experience unparalleled performance with dedicated resources. ",
            "Direct hardware access, eliminating virtualization overhead.",
            "Ideal for HPC, large databases, and resource-intensive workloads. ",
          ]}
        />
      ),
    },
    {
      icon: BsGpuCard,
      title: "Cloud GPU",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CLOUD_GPU}`}
          points={[
            "Accelerate AI, machine learning, and data-intensive applications.",
            "GPU-optimized cloud platform for high-speed computation and processing. ",
            "Reduce time-to-insight with powerful cloud infrastructure.",
          ]}
        />
      ),
    },
    {
      icon: BsServer,
      title: "Block Storage | S3 Storage ",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BLOCK_AND_S3_STORAGE}`}
          points={[
            "High-performance, low-latency storage for critical applications.",
            "Scalable object storage solutions for unstructured data.",
            "Reliable and efficient storage management tailored to your needs.",
          ]}
        />
      ),
    },
    {
      icon: FaServer,
      title: "Load Balancers",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LOAD_BALANCERS}`}
          points={[
            "Ensure optimal performance and high availability with intelligent traffic distribution.",
            "Supports both infrastructure-level and application-level balancing for diverse needs.",
            "Built-in health checks, SSL offloading, and Layer 7 routing for enterprise-grade deployments.",
          ]}
        />
      ),
    },
    {
      icon: TiDeviceDesktop,
      title: "Public IPv4 / IPv6",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.IPV4V6}`}
          points={[
            "Deliver globally reachable, static IPs for VMs, containers, and bare-metal servers.",
            "Supports dual-stack addressing with reduced latency and direct routing.",
            "Fully managed allocation with built-in ACLs, DoS protection, and DNS control.",
          ]}
        />
      ),
    },
    {
      icon: SiKubernetes,
      title: "Kubernetes",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.KUBERNETES}`}
          points={[
            "Deploy CNCF-compliant clusters with built-in RBAC and auto-scaling.",
            "Fully managed control plane via Taikun with 99.99% uptime.",
            "Ideal for multi-tenant apps, dev/test environments, and SaaS workloads.",
          ]}
        />
      ),
    },
    // {
    //   icon: MdOutlineAutoMode,
    //   title: "Platform as a Service (PaaS)",
    //   content: (
    //     <ContentCard
    //       link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PAAS}`}
    //       points={[
    //         "Deploy containerized apps with Git-based CI/CD and auto-scaling runtimes.",
    //         "Supports Docker-native workloads with Java, Node.js, and Python.",
    //         "Managed via Taikun with full observability, rollback, and multi-cloud flexibility.",
    //       ]}
    //     />
    //   ),
    // },
    {
      icon: TiDeviceDesktop,
      title: "Virtual Desktop Infrastructure (VDI) ",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VDI}`}
          points={[
            "Secure access to your desktop from anywhere, on any device.",
            "Centralized management, enhanced security, and seamless user experience.",
            "Boost workforce productivity with flexible cloud-based desktops.",
          ]}
        />
      ),
    },
    {
      icon: FaMicrosoft,
      title: "Managed Microsoft 365",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MICROSOFT_365}`}
          points={[
            "End-to-end M365 management across Outlook, Teams, SharePoint, and OneDrive.",
            "Pre-configured with MFA, DLP, and Microsoft Defender for security and compliance.",
            "Includes user provisioning, policy setup, and hands-on admin support - backed by OneMind as your trusted cloud service provider",
          ]}
        />
      ),
    },
    // {
    //   icon: RiDeviceRecoverLine,
    //   title: "Disaster Recovery ",
    //   content: (
    //     <ContentCard
    //       link={`${MAIN_ROUTES.IAAS}${IAAS_ROUTES.DISASTER_RECOVERY}`}
    //       points={[
    //         "Robust backup, real-time replication, and swift recovery options.",
    //         "Minimize downtime and data loss with tailored recovery plans.",
    //         "Ensure business continuity with a comprehensive DR strategy.",
    //       ]}
    //     />
    //   ),
    // },
  ],
};
